/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Style_Preset_LabelInputs */



/**
* | output |
* | --- |
* | "Style Preset" |
*
* @param {Video_Export_Style_Preset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_style_preset_label = /** @type {((inputs?: Video_Export_Style_Preset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Style_Preset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prereglage de style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stilvoreinstellung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preimpostazione di stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительно заданный стиль")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajuste preestablecido de estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("风格预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルプリセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टाइल प्रीसेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Predefinição de estilo")
	return /** @type {LocalizedString} */ ("Style Preset")
});